import { render, staticRenderFns } from "./arrowRight.vue?vue&type=template&id=495e9738&"
import script from "./arrowRight.vue?vue&type=script&lang=ts&"
export * from "./arrowRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports